/**
 * Resolve locale based on the current path and the current user.
 *
 * @param    {app.core.RouteHandler}  routeHandler  The route handler
 * @param    {app.App}                app           The application instance
 * @returns  {Promise}                A promise that resolves once the task is
 *                                    done.
 */
module.exports = function(routeHandler, app) {
    var i18nService = app.$.i18nService,
        router      = app.$.router,
        user        = app.$.authService.get("user");

    return i18nService.resolveLocale(router.getCurrentPath(), user);
};
